import _ from "lodash";
import {
  getFailed,
  getStarted,
  getSucceeded,
  getEnded,
  statusEnum,
  INBOX_INITIALIZATION,
  INBOX_INGREDIENT_TOGGLE,
  INBOX_SELECT_TOGGLE,
  INBOX_DELETE,
  INBOX_ACCEPT,
  INBOX_FILTER,
  INBOX_CATEGORY_SELECTED,
  CLEAR_INBOX,
} from "../actions/constant";

// import { notifFilter } from "../services/InboxService";
import moment from "moment";
import { convertHHMMForDisplay } from "../lib/helper";


const initialState = {
  isLoading: false,
  status: statusEnum.DEFAULT,
  notifsAll: [],
  notifs: [],
  shareSuccess: false,
  acceptSuccess: false,
  shareError: false,
  shareErrorMsg: "",
  selectedItems: [],
  inboxForm: {
    sortBy: "new",
    category: "00",
  },
  counterState: 0,
  disabled: {
    acceptBtn: true,
    deleteBtn: true,
  },
};

function orderedListMaker(notifsFilter, sortBy) {
  if (sortBy == "null" || sortBy == "new") {
    return _.orderBy(notifsFilter, ["date"], ["desc"]);
  } else if (sortBy == "old") {
    return _.orderBy(notifsFilter, ["date"], ["asc"]);
  } else if (sortBy == "ascending") {
    return _.orderBy(
      notifsFilter,
      [
        // Primary: sender id
        (notif) => String(notif.email || ""),
        // Secondary: reverse chronological within same id
        "date",
      ],
      ["asc", "desc"]
    );
  } else if (sortBy == "descending") {
    return _.orderBy(
      notifsFilter,
      [
        // Primary: sender id
        (notif) => String(notif.email || ""),
        // Secondary: reverse chronological within same id
        "date",
      ],
      ["desc", "desc"]
    );
  }
}

function reducer(state = initialState, action) {
  switch (action.type) {
    case getStarted(INBOX_INITIALIZATION):
      return { ...state, isLoading: true };
    case getSucceeded(INBOX_INITIALIZATION):
      let notifsInitial = action.payload.map((notif) => {
        notif.isExpand = false;
        notif.isSelected = false;
        return notif;
      });

      notifsInitial = orderedListMaker(notifsInitial, state.inboxForm.sortBy);
      return {
        ...state,
        status: statusEnum.SUCCESS,
        notifsAll: notifsInitial,
        notifs: notifsInitial,
      };
    case getEnded(INBOX_INITIALIZATION):
      return { ...state, isLoading: false };

    case INBOX_INGREDIENT_TOGGLE: {
      const notifs = state.notifs.map((notif) => {
        if (notif._id !== action.item._id) return notif;

        const next = { ...notif, isExpand: !notif.isExpand };
        if (next.isExpand && (typeof next.isDone === "undefined" || !next.isDone)) {
          const list = Array.isArray(action.item.items)
            ? action.item.items
            : Array.isArray(action.item.ingredients)
            ? action.item.ingredients
            : [];

          const convertRow = (row) => {
            const units = Array.isArray(row.unit) ? row.unit.map(String) : [];
            const unitFirst = String(row.unitid || units[0] || "");
            const raw = String(row.value || row.size || "");
            const disp = convertHHMMForDisplay(raw, unitFirst);
            if (disp && disp.unit === "445") {
              const newUnits = ["445"].concat(units.filter((u) => String(u) !== "445"));
              return { ...row, value: disp.display, size: disp.display, unitid: "445", unit: newUnits };
            }
            return row;
          };

          // If entries are groups with inner items[], convert inner rows.
          if (list.length && Array.isArray(list[0].items)) {
            next.ingredients = list.map((g) => ({
              ...g,
              items: Array.isArray(g.items) ? g.items.map(convertRow) : [],
            }));
          } else {
            // Flat list (food or other) – convert if applicable, otherwise no-op.
            next.ingredients = list.map(convertRow);
          }

          // meta (safe no-ops for food)
          next.name = action.item.name;
          next.size = action.item.size ? action.item.size : "";
          next.comment = action.item.comment;
          next.isDone = 1;
        }
        return next;
      });
      return { ...state, notifs };
    }

    case INBOX_SELECT_TOGGLE:
      let selectedItems = state.selectedItems;
      let newSelect = [{ cat: action.cat, id: action.id }];
      selectedItems = _.xorBy(selectedItems, newSelect, "id");
      const notifSelectToggles = state.notifs.map((notif) => {
        if (notif._id === action.id) {
          notif.isSelected = !notif.isSelected;
        }
        return notif;
      });
      return {
        ...state,
        notifs: notifSelectToggles,
        selectedItems: selectedItems,
      };
    case getSucceeded(INBOX_DELETE):
      let ids = action.payload;
      let notifsDelete = [];
      let notifsAllDelete = [];
      // remove from notifs
      state.notifs.map((notif) => {
        if (!_.includes(ids, notif._id)) {
          notif.isSelected = false;
          notifsDelete.push(notif);
        }

        return notif;
      });
      state.notifsAll.map((notif) => {
        if (!_.includes(ids, notif._id)) {
          notif.isSelected = false;
          notifsAllDelete.push(notif);
        }

        return notif;
      });
      return {
        ...state,
        notifsAll: notifsAllDelete,
        notifs: notifsDelete,
        status: statusEnum.SUCCESS,
        selectedItems: [],
      };
    case INBOX_FILTER:
      let notifsFilter = state.notifs;
      action.sortBy = action.sortBy == "null" ? "new" : action.sortBy;
      notifsFilter = orderedListMaker(notifsFilter, action.sortBy);
      return {
        ...state,
        notifs: notifsFilter,
        inboxForm: { sortBy: action.sortBy },
      };
    case INBOX_CATEGORY_SELECTED:
      state.selectedItems = [];

      notifsFilter = [];
      state.notifsAll.map((notif) => {
        if (action.cat.target.value === "00") {
          notif.isExpand = false;
          notif.isSelected = false;
          notifsFilter.push(notif);
        } else {
          if (notif.category === action.cat.target.value) {
            notif.isExpand = false;
            notif.isSelected = false;
            notifsFilter.push(notif);
          }
        }

        return notif;
      });
      notifsFilter = orderedListMaker(notifsFilter, "new");
      return {
        ...state,
        notifs: notifsFilter,
        inboxForm: {
          category: action.cat.target.value,
          sortBy: "new",
        },
      };
    case getStarted(INBOX_ACCEPT):
      localStorage.setItem("sharedRecipeCat", state.selectedItems[0].cat);
      return { ...state, acceptSuccess: false, isLoading: true };
    case getSucceeded(INBOX_ACCEPT):
      ids = action.payload;
      notifsDelete = [];
      notifsAllDelete = [];
      // remove from notifs
      state.notifs.map((notif) => {
        if (!_.includes(ids, notif._id)) {
          notif.isExpand = false;
          notif.isSelected = false;
          notifsDelete.push(notif);
        }

        return notif;
      });
      state.notifsAll.map((notif) => {
        if (!_.includes(ids, notif._id)) {
          notif.isExpand = false;
          notif.isSelected = false;
          notifsAllDelete.push(notif);
        }

        return notif;
      });
      // redirect
      return {
        ...state,
        notifsAll: notifsAllDelete,
        isLoading: false,
        notifs: notifsDelete,
        acceptSuccess: true,
        selectedItems: [],
      };

    case getEnded(INBOX_ACCEPT):
      return { ...state, isLoading: false };

    case CLEAR_INBOX:
      return {
        ...state,
        acceptSuccess: false,
      };
    default:
      return state;
  }
}

export default reducer;



// WEBPACK FOOTER //
// ./src/reducers/inboxReducer.js